import type { IconSvgObject } from './types';

const Presentation06Icon: IconSvgObject = [
  ["path", { d: "M12 17L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 22L9.21488 21.183C9.50903 20.8468 9.65611 20.6787 9.85305 20.5894C10.05 20.5 10.2733 20.5 10.72 20.5H13.28C13.7267 20.5 13.95 20.5 14.1469 20.5894C14.3439 20.6787 14.491 20.8468 14.7851 21.183L15.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 17V5C3 3.34315 4.34315 2 6 2L18 2C19.6569 2 21 3.34315 21 5V17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 17H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Presentation06Icon;
